import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HeroCarousel() {
  const hotArticles = articles.filter((a) => a.isHot || a.isTop).slice(0, 3);
  const mainArticle = hotArticles[0];
  const sideArticles = hotArticles.slice(1, 3);

  return (
    <section className="relative w-full overflow-hidden">
      <div className="relative h-[420px] md:h-[520px] w-full">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20cinematic%20cityscape%20at%20night%20with%20moody%20atmospheric%20lighting%2C%20deep%20shadows%20and%20warm%20amber%20street%20lights%2C%20mysterious%20urban%20aesthetic%2C%20film%20noir%20style%2C%20dark%20tonal%20palette%20with%20selective%20warm%20highlights%2C%20editorial%20photography%20with%20dramatic%20contrast%2C%20foggy%20street%20scene%20with%20reflections%20on%20wet%20pavement&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
            alt="黑料91 - 全网最新黑料曝光合集"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50"></div>

        <div className="relative z-10 w-full h-full flex flex-col lg:flex-row gap-4 p-4 md:p-6 pt-20">
          <Link
            to={`/article/${mainArticle.id}`}
            className="flex-1 group cursor-pointer flex flex-col justify-end p-6 md:p-8 rounded-lg overflow-hidden relative min-h-[200px]"
          >
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent rounded-lg"></div>
            <div className="relative z-10">
              <span className="inline-block bg-primary-500 text-background-50 text-xs font-semibold px-2.5 py-1 rounded-full mb-3">
                热点爆料
              </span>
              <h2 className="text-xl md:text-3xl font-heading font-bold text-white mb-3 leading-tight group-hover:text-primary-300 transition-colors duration-200 line-clamp-2">
                {mainArticle.title}
              </h2>
              <p className="text-sm md:text-base text-white/70 line-clamp-2 mb-3">
                {mainArticle.excerpt}
              </p>
              <div className="flex items-center gap-3 text-xs text-white/50">
                <span>{mainArticle.date}</span>
                <span>{(mainArticle.views / 10000).toFixed(1)}万阅读</span>
              </div>
            </div>
          </Link>

          <div className="lg:w-[380px] flex flex-col gap-4">
            {sideArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group cursor-pointer flex gap-3 p-3 rounded-lg bg-background-50/10 backdrop-blur-sm hover:bg-background-50/20 transition-all duration-200"
              >
                <div className="w-24 h-16 md:w-28 md:h-20 rounded-md overflow-hidden flex-shrink-0">
                  <img
                    src={article.heroImageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0 flex flex-col justify-between">
                  <h3 className="text-sm font-semibold text-white line-clamp-2 leading-snug group-hover:text-primary-300 transition-colors duration-200">
                    {article.title}
                  </h3>
                  <span className="text-xs text-white/40">{article.date}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}